
import {getAllGuest,getGuestByPage,deleteGuest,getGuestByKeyWord} from "@/api/login"
import { defineComponent,reactive,ref} from 'vue'
import {ElMessage} from "element-plus"
import { useRouter } from 'vue-router';

export default defineComponent({
  created(){
    this.userlist();
  },
setup() {
let router=useRouter();
let add:any =localStorage.getItem("token");
const lust = JSON.parse(add)
const tableData = ref([]);
const userlist = ()=>{
  var params = new URLSearchParams();
  var paramsall = new URLSearchParams();
  paramsall.append('userid', lust.userId);
    paramsall.append('token',lust.token);
    params.append('userid', lust.userId);
    params.append('token',lust.token);
    params.append('page',String(formInline.page));
    params.append('size',String(formInline.limit));
    getGuestByPage(params).then((res)=>{
      let data:any = res;
      tableData.value = data.guestList;
      
    })
    getAllGuest(paramsall).then((res)=>{
      let data:any = res;
      formInline.total = data.guestList.length;
      console.log(data.guestList.length,"6666666666")
    })
}

const handleDelete = (index: number,row:any) => {//deleteGuest
  var paramsall = new URLSearchParams();
  paramsall.append('userid', lust.userId);
  paramsall.append('token',lust.token);
  paramsall.append('guestid',row.guestId);
  deleteGuest(paramsall).then((res)=>{
    let data:any = res;
    if(data.errorcode == 0){
      ElMessage.success(data.resultmsg)
      userlist();
    }else{
      ElMessage.error(data.resultmsg)
    }
    console.log(data,"113")
  })
console.log(row.guestId,"110")
   
}
const state = ref(false)
const dialogFormVisible = ref(false)
const formLabelWidth = '140px'
const form = reactive({
  name: '',
  region: '',
  date1: '',
  date2: '',
  delivery: false,
  type: [],
  resource: '',
  desc: '',
         })
const formInline = reactive({
  devicesn: '',
  phone: '',
  page:1,
  limit:20,
  total:100,
})
const onSubmit = () => {
 var params = new URLSearchParams();
    params.append('userid', lust.userId);
    params.append('token',lust.token);
    params.append('keyword', formInline.devicesn);
    getGuestByKeyWord(params).then((res)=>{
      let data:any = res;
      if(data.errorcode != 0){
        ElMessage.error(data.resultmsg)
      }else{
        tableData.value = data.guestList;;
      }
    })
}

const getPageList=(pager:any)=> {
  formInline.page = pager;
      console.log(formInline.page,"1888")
    var params = new URLSearchParams();
    params.append('userid', lust.userId);
    params.append('token',lust.token);
    params.append('page',String(formInline.page));
    params.append('size',String(formInline.limit));
    getGuestByPage(params).then((res)=>{
      let data:any = res;
      tableData.value = data.guestList;
      console.log(data,"6666666666")
    })
    }
 const handleSizeChange=(limit:any)=> {
  formInline.limit = limit;
    }
        return {
            dialogFormVisible,
            formLabelWidth,
            form,
            handleDelete,
            tableData,
            userlist,
            formInline,
            onSubmit,
            state,
            getPageList,
            handleSizeChange,

        }
    },
})
